(ns trellis.tooltip
  (:require
   ["@material-ui/core/styles" :refer [withStyles]]
   [material-ui.core :as m]
   [reagent.core :as r]))

(def tooltip (-> ((withStyles #js {:tooltip #js {:backgroundColor "rgb(51, 65, 85)"
                                                 :fontFamily "Lexend Deca, Helvetica, Arial, sans-serif"
                                                 :fontWeight "300"
                                                 :fontSize "14px"
                                                 :lineHeight "24px"
                                                 :letterSpacing "0px"
                                                 :color "white"
                                                 :paddingTop "10px"
                                                 :paddingBottom "10px"
                                                 :paddingLeft "16px"
                                                 :paddingRight "16px"}
                                   :arrow #js {:color "rgb(51, 65, 85)"}})
                  m/Tooltip)
                 (r/adapt-react-class)))
